var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 115,
    viewBox: "0 0 76 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.619 0C16.8425 0 0 17.1623 0 38.3333C0 45.1423 1.79443 51.5104 4.84909 57.0496C5.35648 57.9696 5.88832 58.8752 6.46577 59.7473L37.619 115L68.7723 59.7473C69.2519 59.0237 69.6657 58.2571 70.0936 57.5L70.3899 57.0496C73.4417 51.5104 75.238 45.1423 75.238 38.3333C75.238 17.1623 58.3941 0 37.619 0ZM37.619 19.1667C48.0066 19.1667 56.4285 27.7481 56.4285 38.3333C56.4285 48.9181 48.0066 57.5 37.619 57.5C27.231 57.5 18.8095 48.9181 18.8095 38.3333C18.8095 27.7481 27.231 19.1667 37.619 19.1667Z",
    fill: "#FC7700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoad);
export default __webpack_public_path__ + "static/media/load.8cbfd17275655fe1ad2b480aa3590ad2.svg";
export { ForwardRef as ReactComponent };